// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusCard_root__3ZGD4","text":"StatusCard_text__1ggvV","accent":"StatusCard_accent__-xAdX"};